<template>
	<div>
		<p class="check-head">
			<i class="fa fa-file-text-o" aria-hidden="true"></i> <span>{{ $t("chatMessageCheck.checkUploadReminder") }}</span>
		</p>
		<p class="supplier-name">
			<span>{{ message.cheque_supplier_name }}</span>
		</p>
		<p class="check-text-title">
			<span>{{ message.cheque_upload_datetime.date | messageDateFormat }}</span>
		</p>
		<div class="check-btn">
			<button @click="handleCheckDetailsVisible">{{ $t("chatMessageCheck.checkCheckUpload") }}</button>
		</div>
		<el-dialog :title="$t('chatMessageCheck.checkDetails')" :visible.sync="checkDetailsVisible" width="40%" :show-close="false" :append-to-body="true">
			<CheckDetails :checkDetailData="checkDetailData"
		/></el-dialog>
	</div>
</template>
<script>
import CheckDetails from "./chat-message-check-details.vue";

import { getCheques } from "@/services/api-v2/api-v2";
export default {
	name: "chat-message-check",

	components: {
		CheckDetails,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			// 支票详情显示设置
			checkDetailsVisible: false,

			// 支票详情数据
			checkDetailData: {},
		};
	},

	methods: {
		async handleCheckDetailsVisible() {
			try {
				const { data } = await getCheques(this.message.cheque_id);
				this.checkDetailData = data;
				this.checkDetailsVisible = true;
			} catch (error) {
				this.$message.error(error);
			}
		},
	},
};
</script>
<style lang="less" scoped>
.check-head {
	margin: 0;

	> i {
		font-weight: 500;
		color: black;
		font-size: 16px;
	}
	> span {
		font-weight: 600;
		color: black;
		font-size: 16px;
		margin-left: 3px;
	}
}

.check-text-title {
	display: flex;
	display: -webkit-flex;
	justify-content: space-between;

	> span {
		color: #404040;
		font-weight: 500;
	}
}

.check-btn {
	width: 192px;
	border-top: 1px solid white;
	padding-top: 10px;

	> button {
		padding: 0;
		width: 100%;
		border: 0;
		background: rgba(0, 0, 0, 0);
		font-size: 16px;
		font-weight: 600;
	}
}

.supplier-name {
	font-weight: 600;
	color: black;
	font-size: 14px;
}
</style>
